import { render } from "./InfoMessage.vue?vue&type=template&id=13abad70&scoped=true"
import script from "./InfoMessage.vue?vue&type=script&lang=js"
export * from "./InfoMessage.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-13abad70"

export default script